module.exports = __webpack_public_path__ + "img/img_quanyi02@2x.967d4e8a.png";